<template>
    <div class="flex w-full px-6 py-3 bg-gray-50 border-b border-gray-400 h-16 page-header" :class="{'page-header-fixed' : fixed}">
        <div class="flex items-center whitespace-no-wrap">
            <h1 class="text-sm lg:text-2xl font-light text-gray-700"><slot name="title"></slot></h1>
        </div>
        <div class="relative flex-grow">
            <div class="flex flex-row justify-end">
                <slot name="buttons" v-if="buttonCount > 0">
                    <template v-for="(button, index) in buttons.filter((b) => b.display !== false)">
                        <a href="javascript:void(0)"
                            v-if="button.type === 'method'"
                            v-bind:key="index"
                            class="border text-xs lg:text-sm px-4 py-1 mt-1 -mr-px whitespace-no-wrap"
                            :class="[ button.class ? button.class : 'bg-gray-200 hover:bg-white border-gray-400' ]"
                            @click="callMethod(button.method)">
                            <font-awesome-icon class="mr-1 text-white"
                                :class="[button.iconClass ? button.iconClass : '']"
                                :icon="['fas', button.icon]" />
                            {{ button.label }}
                        </a>
                        <router-link v-if="button.type === 'router-link'"
                            v-bind:key="index"
                            class="border text-xs lg:text-sm px-4 py-1 mt-1 -mr-px whitespace-no-wrap"
                            :class="[ button.class ? button.class : 'bg-gray-200 hover:bg-white border-gray-400' ]"
                            tag="a"
                            :to="button.link"
                            :target="button.target ? button.target : ''">
                            <font-awesome-icon class="mr-1 text-white"
                                :class="[button.iconClass ? button.iconClass : '']"
                                :icon="['fas', button.icon]" />
                            {{ button.label }}
                        </router-link>
                    </template>
                </slot>
                <slot name="dropdown" v-if="additionalCount > 0">
                    <button type="button" class="border text-sm px-4 py-1 mt-1 -mr-px bg-gray-200 hover:bg-white border-gray-400 focus:outline-none" :class="{'bg-grey-lightest': dropdownOpen }" v-on:click="toggleDropdown" v-click-outside="closeDropdown"><font-awesome-icon :icon="['fas', 'caret-down']" /></button>
                    <ul class="list-none absolute bg-white border-r border-l border-t border-gray-400 z-10" style="top:34px; right: -1px;" role="menu" :class="{'block': dropdownOpen, 'hidden': !dropdownOpen  }">
                        <li v-for="(item, index) in additional.filter((a) => a.display !== false)" v-bind:key="index">
                            <a href="javascript:void(0)" v-if="item.type === 'method'" class="block py-2 px-4 text-left text-gray-800 text-sm no-underline hover:bg-gray-200 border-b border-gray-400" :class="[item.width ? item.width : 'w-50']" @click="callMethod(item.method)"><font-awesome-icon class="mr-2" :class="[item.iconClass ? item.iconClass : '']" :icon="['fas', item.icon]" />{{ item.label }}</a>
                            <router-link tag="a" v-if="item.type === 'router-link'" class="block py-2 px-4 text-left text-gray-800 text-sm no-underline hover:bg-gray-200 border-b border-gray-400" :class="[item.width ? item.width : 'w-50']" :to="item.link"><font-awesome-icon class="mr-2" :class="[item.iconClass ? item.iconClass : '']" :icon="['fas', item.icon]" />{{ item.label }}</router-link>
                        </li>
                    </ul>
                </slot>
                <slot name="custom"></slot>
            </div>
        </div>
    </div>
</template>

<script>
    import ClickOutside from 'vue-click-outside'

    export default {
        props: {
            buttons: {
                default: () => [],
                type: Array
            },
            additional: {
                default: () => [],
                type: Array
            },
            leftWidth: {
                default: 'w-1/2',
                type: String
            },
            rightWidth: {
                default: 'w-1/2',
                type: String
            },
            fixed: {
                default: false,
                type: Boolean
            }
        },
        data() {
            return {
                dropdownOpen: false
            }
        },
        methods: {
            callMethod: function(method){
                this.$emit('method', method);
            },
            toggleDropdown: function(){
                this.dropdownOpen = !this.dropdownOpen;
            },
            closeDropdown: function(){
                this.dropdownOpen = false;
            }
        },
        computed: {
            additionalCount () {
                return this.additional.filter(item => item.display || item.display === undefined).length;
            },
            buttonCount () {
                return this.buttons.filter(item => item.display || item.display === undefined).length;
            },
        },
        directives: {
            ClickOutside
        },
    }
</script>
